import React from "react"
import NewsletterSubscribe from "./newsletter-subscribe"
import LatestArticleBanner from "./latest-article-banner"

const BlogHero = () => {
  return (
    <div className="w-full bg-gradient_header">
      <div className="w-full max-w-w2_xl flex flex-col lg:flex-row items-center lg:items-start xl:items-center justify-between gap-5 md:gap-10 lg:gap-3 xl:gap-5 px-4 lg:px-px1_l xl:px-px1_xl pt-8 lg:pt-[60px] xl:pt-[70px] mb-8 md:mb-[124px] lg:mb-2 xl:mb-4 mx-auto"
      >
        {/* Texts and Newsletter - Left Side */}
        <NewsletterSubscribe />

        {/* Latest Article Banner - Right Side */}
          <div className="w-full lg:w-1/2 xl:w-[44%] max-w-[530px] xl:max-w-[626px] mx-auto lg:mx-0">
            <div className="w-full h-full image-cover">
              <LatestArticleBanner />
            </div>
          </div>
      </div>
    </div>
  )
}

export default BlogHero
